import React from 'react'
import SEO from '../components/sections/SEO'
import SEOImg from '../assets/images/gallery/small/clock/1.webp'
import HeaderShort from '../components/sections/HeaderShort'
import Footer from '../components/sections/Footer'
import footerLogo from '../assets/images/logos/genr8-logo-w.svg'
import ServiceFabClockSection from '../components/sections/ServiceFabClockSection'

function ServiceFabClock() {
  return (
    <>
      <SEO 
        title='Services | Clocks'
        desc='Release your imagination and design your clock with one of the most beautiful Jamaican woods we have in stock' 
        keywords='Clocks, Jamaican Clocks'
        url='https://genr83d.com/services/fabrication/customized-clocks'
        img={SEOImg}
      />
      <HeaderShort
        head='Customized Clocks'
        url='/services'
        prev='Services'
        title='Customized Clocks'
      />
      <ServiceFabClockSection />
      <Footer logo={footerLogo} />
    </>
  )
}

export default ServiceFabClock
